/**
 * @name house-cog
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuNTg0IDIxSDVhMiAyIDAgMDEtMi0ydi05YTIgMiAwIDAxLjcwOS0xLjUyN2w3LTZhMiAyIDAgMDEyLjU4MiAwbDcgNkEyIDIgMCAwMTIxIDEwLjAwMXYuNTgzIiAvPgogIDxwYXRoIGQ9Ik0xNCAxMkgxMGExIDEgMCAwMC0xIDF2OCIgLz4KICA8cGF0aCBkPSJtMTQuMzA1IDE5LjUzLjkyMy0uMzgyIiAvPgogIDxwYXRoIGQ9Im0xNS4yMjkgMTYuODUyLS45MjQtLjM4MyIgLz4KICA8cGF0aCBkPSJtMTYuODUyIDE1LjIyOC0uMzgzLS45MjMiIC8+CiAgPHBhdGggZD0ibTE2Ljg1MiAyMC43NzMtLjM4My45MjQiIC8+CiAgPHBhdGggZD0ibTE5LjE0OCAxNS4yMjguMzgzLS45MjMiIC8+CiAgPHBhdGggZD0ibTE5LjUzIDIxLjY5Ny0uMzgyLS45MjQiIC8+CiAgPHBhdGggZD0ibTIwLjc3MyAxNi44NTIuOTIyLS4zODMiIC8+CiAgPHBhdGggZD0ibTIwLjc3MyAxOS4xNDguOTIyLjM4MyIgLz4KICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjE4IiByPSIzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/house-cog
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const HouseCog: string = `
<svg
  class="lucide lucide-house-cog"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10.584 21H5a2 2 0 01-2-2v-9a2 2 0 01.709-1.527l7-6a2 2 0 012.582 0l7 6A2 2 0 0121 10.001v.583" />
  <path d="M14 12H10a1 1 0 00-1 1v8" />
  <path d="m14.305 19.53.923-.382" />
  <path d="m15.229 16.852-.924-.383" />
  <path d="m16.852 15.228-.383-.923" />
  <path d="m16.852 20.773-.383.924" />
  <path d="m19.148 15.228.383-.923" />
  <path d="m19.53 21.697-.382-.924" />
  <path d="m20.773 16.852.922-.383" />
  <path d="m20.773 19.148.922.383" />
  <circle cx="18" cy="18" r="3" />
</svg>
`;

export default HouseCog;
